module.exports = __webpack_public_path__ + "img/iconDevice-Green.49c8598e.svg";